import { render, staticRenderFns } from "./NewEmailButton.vue?vue&type=template&id=b08dcf3a&"
import script from "./NewEmailButton.vue?vue&type=script&lang=js&"
export * from "./NewEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports